import React from 'react';
import { formatTime } from '../../hooks/useTranscriptViewer';

/**
 * One speaker paragraph. Memoized so that playback ticks only re-render the
 * paragraph whose active word changed, not every word in the transcript.
 *
 * activeWordIndex is -1 for paragraphs that aren't currently being spoken.
 * Word clicks are handled by delegation on the <p> (via data-start) so we
 * don't create a handler per word.
 */
function TranscriptParagraph({
  group,
  groupIndex,
  isActive,
  activeWordIndex,
  getWordSearchClass,
  onSeek,
}) {
  const handleTextClick = (e) => {
    const word = e.target.closest('[data-start]');
    if (word) onSeek(Number(word.dataset.start));
  };

  return (
    <div className={`paragraph-group ${isActive ? 'active' : ''}`}>
      <div className="paragraph-header" onClick={() => onSeek(group.start)}>
        <span className="speaker-label">Speaker {group.speaker}</span>
        <span className="timestamp">{formatTime(group.start)}</span>
      </div>
      <p className="paragraph-text" onClick={handleTextClick}>
        {group.words && group.words.length > 0 ? (
          group.words.map((word, wi) => (
            <span
              key={wi}
              data-start={word.start}
              className={`transcript-word${wi === activeWordIndex ? ' word-active' : ''}${getWordSearchClass(groupIndex, wi)}`}
            >
              {word.text}{' '}
            </span>
          ))
        ) : (
          <span data-start={group.start}>{group.text}</span>
        )}
      </p>
    </div>
  );
}

export default React.memo(TranscriptParagraph);
